interface ValuePropsData {
    image: string;
    image_alt: string;
    heading: string;
    content: string;
}

const valuePropsData = [
    {
        image: "https://cdn.buttercms.com/psvu5EZ0SwSqAIyvxSfa",
        image_alt: "Icon of four organized flowers representing keeping wedding planning organized",
        heading: "Stay Organized",
        content: "Keep your wedding details in one easy-to-use place.",
    },
    {
        image: "https://cdn.buttercms.com/ErObINLRRjWLcPbFzpnr",
        image_alt: "Icon of a clock representing how the wedding budget template saves you time while wedding planning.",
        heading: "Save Time",
        content: "Get a ready-to-go, beautifully structured template.",
    },
    {
        image: "https://cdn.buttercms.com/f0qwq5dwQBmnzbA1yu4l",
        image_alt: "Icon of a hand and flower representing how the wedding budget template reduces stress.",
        heading: "Reduce Stress",
        content: "Feel confident and in control at every step leading up to your big day.",
    },
    {
        image: "https://cdn.buttercms.com/vgIP13ueS4KJp8ddrBEu",
        image_alt: "Icon of a calendar showing how the wedding budget template helps you plan a wedding smarter.",
        heading: "Plan Smarter",
        content: "Make informed decisions quickly with built-in tools and tracking.",
    }
]

export default { valuePropsData };
export type { ValuePropsData };